export default __webpack_public_path__ + "static/CircularStd-BoldItalic-390d3102df74df350fe3b27cca63f9f5.ttf";